import axios from 'axios';
import { z } from 'zod';

const API_URL = process.env.REACT_APP_API_URL;

export interface RequestResponse {
   error?: {
      message: string;
      code: number;
   };
   message?: any;
   data?: any;
}

const requestConfig = {
   baseURL: API_URL,
   headers: {
      'Content-Type': 'application/json',
   },
   withCredentials: true, // send cookies when cross-domain requests
};

const imageRequestConfig = {
   baseURL: API_URL,
   headers: {
      'Content-Type': 'multipart/form-data',
   },
   withCredentials: true, // send cookies when cross-domain requests
};

// Axios Request Interceptor to append referralCode
const addDynamicParams = (config: any) => {
   const urlParams = new URLSearchParams(window.location.search);
   const trackingParams = ['referral', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

   const url = new URL(config.url!, API_URL);

   trackingParams.forEach((param) => {
      const value = urlParams.get(param);
      if (value) url.searchParams.set(param, value);
   });

   config.url = url.pathname + url.search; // Keep path + params
   return config;
};

export const removeDynamicParams = () => {
   const url = new URL(window.location.href);
   const trackingParams = ['referral', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
   let modified = false;
   trackingParams.forEach((param) => {
      if (url.searchParams.has(param)) {
         url.searchParams.delete(param);
         modified = true;
      }
   });

   if (modified) {
      window.history.replaceState({}, document.title, url.pathname + url.search);
   }
};

const allowedEndpoints = ['/users', '/orders'];

const responseInterceptor = (response: any) => {
   const requestUrl = new URL(response.config.url, API_URL).pathname; // Extract path

   if (response.status === 200 && allowedEndpoints.includes(requestUrl)) {
      removeDynamicParams();
   }
   return response;
};

export const axiosSecure = axios.create(requestConfig);
export const axiosForImage = axios.create(imageRequestConfig);
axiosSecure.interceptors.request.use(addDynamicParams);
axiosForImage.interceptors.request.use(addDynamicParams);
axiosSecure.interceptors.response.use(responseInterceptor);
axiosForImage.interceptors.response.use(responseInterceptor);

export const handleError = (error: any): RequestResponse => {
   if (error.response?.status === 500) console.error(error.response?.data);
   if (process.env.REACT_APP_ENV === 'dev') {
      console.log('error', error.response?.data);
      console.log('status', error.response?.status);
   }
   return {
      error: {
         message: error.response?.data.message || error.response?.data,
         code: error.response?.status,
      },
   };
};

export const handleResponse = <T>(response: any): RequestResponse => {
   let responseData = response.data.data as T;

   return {
      data: responseData,
      message: response.data.message,
   };
};
